import React from "react";

import {
  AddressBook,
  AddSellerPlan,
  Carrier,
  CurrencyPayoutSetting,
  CurrencyRateSetting,
  EditSubscriptionPlan,
  Fulfillment,
  LocationMapping,
  ManageGeolocation,
  SellerPlanList,
  ManageFulfillmentDetail,
  ManageFulfillmentTrackingDetails,
  ManageVendorExport,
  OrderLiveConnectSetting,
  PackingSlipSetting,
  PlanPreview,
  ProductExportSetting,
  ShopifyInstall,
} from "app/setup/modules";

import CreditNote from "app/setup/modules/creditNote";
import InvoiceSetting from "app/setup/modules/invoiceSetting";
import OrderACSSetting from "app/setup/modules/orderACSSetting";

// // order features
import {
  BulkOrderFulfillment,
  ExportOrder,
  ExportOrderPDF,
  ManageCustomerDetails,
  OrderAutoExpiry,
  OrderList,
  OrderSetting,
  OrderSlip,
  OrderView,
} from "app/orders/modules";

import { ExportReport, Dashboard, ExportReportPDF } from "app/dashboard/modules";

// // service variant routes

import ServiceVariantAdd from "app/product/modules/variantServiceAdd";
import ServiceVariantEdit from "app/product/modules/variantServiceEdit";

// provider features
import {
  ExportVendor,
  ExportVendorPDF,
  VendorList,
  VendorAdd,
  VendorEdit,
  DownloadVendorCSV,
  VendorView,
  DownloadInviteCSV,
  VendorReview,
} from "app/vendors/modules";

// provider advance features
import {
  AdvanceProviderList,
  AdvanceProviderView,
  HolidaySetting,
  ManageVendor,
  ManageVendorAccess,
  AdvanceVendorAccess,
  ManageVendorReview,
  ManageVendorSubscription,
  VendorFormLabel,
} from "app/advanceVendor/modules";

import Reporting from "app/reporting/modules";

// // sellers features
import { SellerList, SellerProfileView } from "app/sellers/modules";
import Invitation from "app/invitations/modules";
import Quote from "app/quote/modules";

// // product features
import {
  BulkProductEdit,
  ExportProductCSV,
  ExportProductAsCSV,
  ExportProductPDF,
  ProductMetafield,
  ProductApprovalSetting,
  ProductAttachmentSetting,
  ProductList,
  ProductListSetting,
  // ProductAdd,
  ProductSetting,
  // ProductEdit,
  ProductReview,
  ProductConnectShop,
  ProductPriceSetting,
  ShopifyCallback,
  ShopifyProducts,
  // VariantAdd,
  // VariantEdit,
  WixProducts,
  WooCommerceProducts,
} from "app/productOld/modules";

// // new product form
import {
  ProductAdd,
  ProductEdit,
  ProductEditCsv,
  ProductServiceEdit,
  VariantAdd,
  VariantEdit,
  WixCallback,
  WixConnect,
} from "app/product/modules";

// // onboarding features
import {
  Branding,
  Commission,
  CustomizeFont,
  Discount,
  DynamicDiscount,
  FeaturePanel,
  Markup,
  PaymentConnect,
  PaymentService,
  PaypalCallBack,
  ProductFormLabel,
  ProductTagSetting,
  ReportSetting,
  Settings,
  StripeCallBack,
  StripeReturn,
  Terms,
} from "app/onboarding/modules";

import Analytics from "app/analytics/modules";
import AnalyticsReport from "app/analytics/modules/report";

import CommissionRevenue from "app/analytics/modules/operator/commissionRevenue/commissionRevenue";
// // import OrderAnalytics from "app/analytics/modules/provider/orderAnalytics/orderAnalytics";
// // import ProductAnalytics from "app/analytics/modules/provider/productAnalytics/productAnalytics";

// plan features
import {
  UpdatePlan,
  UpdatePayment,
  Plan,
  // PlanCheckout
} from "app/plans";

// user management features
import PrivateRoute from "routes/private/privateRoute";
import UserDatabaseSetting from "app/setup/modules/userDatabaseSetting";

// shipping features
import { Shipping, AdvanceShipping } from "app/shipping/modules";
// payment features
import {
  PaymentList,
  Invoice,
  ExportPayment,
  ExportPaymentPDF,
  SchedulePayment,
  TransactionFeesSetting,
} from "app/payments/modules";
import { EmailTemplate, EditEmailTemplate } from "app/emailTemplate/modules";

import {
  ActivityList,
  Association,
  AutomaticPayouts,
  BulkActivity,
  BulkEditActivity,
  ChangePassword,
  Chat,
  ChatSetting,
  ContactUs,
  CustomDomain,
  DigestSetting,
  EditProfile,
  Maintenance,
  Notification,
  OnboardingList,
  UserSession,
  ViewActivity,
  ViewEditActivity,
} from "app/userManagement/modules";

import ExpressPaymentSetting from "app/payments/modules/expressPaymentSetting";
import PaymentExportSetting from "app/payments/modules/exportSetting";
import ManageTax from "app/setup/modules/manageTax";
import ManageOrderTax from "app/setup/modules/manageOrderTax";
import OrderExportSetting from "app/orders/modules/exportSetting";
import CreditNoteList from "app/payments/modules/creditNoteList";

import {
  BigCommerceConnect,
  LakeShopifyProducts,
  LakeBigCommerceProducts,
  LakeVariantAdd,
  LakeVariantEdit,
  ProductLakeAdd,
  ProductLakeEdit,
  ProductLakeList,
  //   ProductLakeReview,
  //   // ProductLakeApprovalSetting,
} from "app/productLake/modules";

import {
  ExportOrderLakeCsv,
  ExportOrderLakePdf,
  OrderLakeList,
  OrderLakeView,
  OrderLakeSlip,
} from "app/orderLake/modules";
// // payment-lake
// import UpgradAppPermission from "app/appPermission/modules/UpgradAppPermission";
import { LakePaymentList, PaymentInvoice } from "app/paymentsLake/modules";
// import PrivateRouter from "layout/private/components/privateRouter/privateRouter";
import { Route } from "react-router-dom";

// const NotFound = () => <h1>Not Found Component</h1>;
import { NotFound } from "layout/private/components";
import { GenericShopifyCallback } from "app/productOld/modules/generic";

// const routes = [{ path: "/*", element: PrivateRouter }];

const routes = [
  { path: "/", element: <Dashboard /> },
  { path: "/activity", element: <ActivityList /> },
  { path: "/analytics", element: <Analytics /> },
  { path: "/analytics/report", element: <AnalyticsReport /> },
  // { path: "/analytics/order-analytics", element: <OrderAnalytics /> },
  // { path: "/analytics/product-analytics", element: <ProductAnalytics /> },
  { path: "/analytics/order-commission-revenue", element: <CommissionRevenue /> },
  { path: "/setting/report", element: <ReportSetting /> },
  { path: "/activity/bulk", element: <BulkActivity /> },
  { path: "/activity/bulk-edit", element: <BulkEditActivity /> },
  { path: "/activity/view/:id", element: <ViewActivity /> },
  { path: "/activity/edit/view/:id", element: <ViewEditActivity /> },
  { path: "/association", element: <Association /> },
  { path: "/branding", element: <Branding /> },
  { path: "/bigCommerce/connect", element: <BigCommerceConnect /> },
  { path: "/commission", element: <Commission /> },
  { path: "/contact-us", element: <ContactUs /> },
  { path: "/change-password", element: <ChangePassword /> },
  { path: "/chat", element: <Chat /> },
  { path: "/chat-setting", element: <ChatSetting /> },
  { path: "/domain", element: <CustomDomain /> },
  { path: "/customize/fonts", element: <CustomizeFont /> },
  { path: "/file-download/vendor", element: <DownloadVendorCSV /> },
  { path: "/file-download/invite", element: <DownloadInviteCSV /> },
  { path: "/setting/product/metafield", element: <ProductMetafield /> },
  { path: "/setting/product/listing", element: <ProductListSetting /> },
  { path: "/profile", element: <EditProfile /> },
  { path: "/invitation", element: <Invitation /> },
  { path: "/invoice/:id/:lineItemId", element: <Invoice /> },
  { path: "/onboard-activity", element: <OnboardingList /> },
  { path: "/orders", element: <OrderList /> },
  { path: "/order-lake", element: <OrderLakeList /> },
  { path: "/order-slip/:id", element: <OrderSlip /> },
  { path: "/orders/view/:id", element: <OrderView /> },
  { path: "/orders/bulk", element: <BulkOrderFulfillment /> },
  { path: "/orderlake-slip/:id", element: <OrderLakeSlip /> },
  { path: "/order-lake/view/:id", element: <OrderLakeView /> },
  { path: "/export/order", element: <ExportOrder /> },
  { path: "/export/order/pdf", element: <ExportOrderPDF /> },
  { path: "/export/order-lake", element: <ExportOrderLakeCsv /> },
  { path: "/export/order-lake/pdf", element: <ExportOrderLakePdf /> },
  { path: "/export/report", element: <ExportReport /> },
  { path: "/export/report/pdf", element: <ExportReportPDF /> },
  { path: "/maintenance", element: <Maintenance /> },
  { path: "/export/payment", element: <ExportPayment /> },
  { path: "/export/payment/pdf", element: <ExportPaymentPDF /> },
  { path: "/export/product", element: <ExportProductCSV /> },
  { path: "/export/product/csv", element: <ExportProductAsCSV /> },
  { path: "/export/product/pdf", element: <ExportProductPDF /> },
  { path: "/payment-connect", element: <PaymentConnect /> },
  { path: "/payments", element: <PaymentList /> },
  { path: "/payment-lake", element: <LakePaymentList /> },
  { path: "/payment-lake/invoice/:id", element: <PaymentInvoice /> },
  { path: "/payments/credit-note", element: <CreditNoteList /> },
  { path: "/payouts", element: <AutomaticPayouts /> },
  // { path: "/paypal-callback", element: <PaypalCallBack /> }, // deprecated by /paypal/callback
  { path: "/plan", element: <Plan /> },
  // { path: "/plan/checkout", element: <PlanCheckout /> },
  { path: "/products", element: <ProductList /> },
  { path: "/product-lake", element: <ProductLakeList /> },
  { path: "/products/add", element: <ProductAdd /> },
  { path: "/products/add/shop", element: <ProductConnectShop /> },
  { path: "/product-lake/add", element: <ProductLakeAdd /> },
  { path: "/products/edit/:id", element: <ProductEdit /> },
  { path: "/product-lake/edit/:id", element: <ProductLakeEdit /> },
  { path: "/product-lake/shopify", element: <LakeShopifyProducts /> },
  { path: "/product-lake/bigcommerce", element: <LakeBigCommerceProducts /> },
  { path: "/products/view/:id", element: <ProductEdit /> },
  { path: "/products/service/edit/:id", element: <ProductServiceEdit /> },
  { path: "/products/review/:id", element: <ProductReview /> },
  { path: "/products/shopify", element: <ShopifyProducts /> },
  { path: "/products/wix", element: <WixProducts /> },
  { path: "/products/woocommerce", element: <WooCommerceProducts /> },
  { path: "/products/bulk/edit", element: <BulkProductEdit /> },
  { path: "/products/edit", element: <ProductEditCsv /> },
  { path: "/operators", element: <SellerList /> },
  { path: "/operators/view/:id", element: <SellerProfileView /> },
  { path: "/quotes", element: <Quote /> },
  { path: "/reporting", element: <Reporting /> },
  { path: "/session", element: <UserSession /> },
  { path: "/setting", element: <Settings /> },
  { path: "/setting/address", element: <AddressBook /> },
  { path: "/setting/carrier", element: <Carrier /> },
  { path: "/setting/currency/payout", element: <CurrencyPayoutSetting /> },
  { path: "/setting/currency/rate", element: <CurrencyRateSetting /> },
  { path: "/setting/customer", element: <ManageCustomerDetails /> },
  { path: "/setting/digest", element: <DigestSetting /> },
  { path: "/setting/discount", element: <Discount /> },
  { path: "/setting/product/label", element: <ProductFormLabel /> },
  { path: "/setting/product/tag", element: <ProductTagSetting /> },
  { path: "/setting/fulfillment", element: <Fulfillment /> },
  { path: "/setting/location", element: <LocationMapping /> },
  { path: "/setting/manage-fulfillment", element: <ManageFulfillmentDetail /> },
  { path: "/setting/manage-fulfillment-tracking", element: <ManageFulfillmentTrackingDetails /> },
  { path: "/setting/product/geolocation", element: <ManageGeolocation /> },
  { path: "/setting/markup", element: <Markup /> },
  { path: "/setting/notification", element: <Notification /> },
  { path: "/setting/order/acs", element: <OrderACSSetting /> },
  { path: "/setting/order", element: <OrderSetting /> },
  { path: "/setting/order/discount", element: <DynamicDiscount /> },
  { path: "/setting/order/export", element: <OrderExportSetting /> },
  { path: "/setting/order-expiry", element: <OrderAutoExpiry /> },
  { path: "/setting/order/live-connect", element: <OrderLiveConnectSetting /> },
  { path: "/setting/payment", element: <PaymentService /> },
  { path: "/setting/payment/transaction-fees", element: <TransactionFeesSetting /> },
  { path: "/setting/payment/export", element: <PaymentExportSetting /> },
  { path: "/setting/payment/express-payment", element: <ExpressPaymentSetting /> },
  { path: "/setting/payment/invoice", element: <InvoiceSetting /> },
  { path: "/setting/product", element: <ProductSetting /> },
  { path: "/setting/product/price", element: <ProductPriceSetting /> },
  { path: "/setting/product/approval", element: <ProductApprovalSetting /> },
  { path: "/setting/product/export", element: <ProductExportSetting /> },
  { path: "/setting/schedule-payment", element: <SchedulePayment /> },

  // { path: "/setting/product-lake/approval", element: <ProductLakeApprovalSetting /> },
  { path: "/setting/tax", element: <ManageTax /> },
  { path: "/setting/user/database", element: <UserDatabaseSetting /> },
  { path: "/setting/tax-rate", element: <ManageOrderTax /> },
  { path: "/setting/attachment", element: <ProductAttachmentSetting /> },
  { path: "/shipping", element: <Shipping /> },
  { path: "/shipping/advance", element: <AdvanceShipping /> },
  { path: "/stripe/callback", element: <StripeCallBack /> },
  { path: "/stripe/return", element: <StripeReturn /> },
  { path: "/providers/shopify-callback", element: <ShopifyCallback /> },
  { path: "/shopify/callback", component: GenericShopifyCallback },
  { path: "/providers/shopify/install", element: <ShopifyInstall /> },
  { path: "/wix/callback", element: <WixCallback /> },
  { path: "/wix/connect", element: <WixConnect /> },
  { path: "/terms", element: <Terms /> },
  { path: "/update/plan", element: <UpdatePlan /> },
  { path: "/update-payment", element: <UpdatePayment /> },
  { path: "/export/vendor", element: <ExportVendor /> },
  { path: "/export/vendor/pdf", element: <ExportVendorPDF /> },
  // { path: "/variants/add/:productId", element: <VariantAdd /> },
  { path: "/variants/add/:productId", element: <VariantAdd /> },
  { path: "/lake-variants/add/:productId", element: <LakeVariantAdd /> },
  { path: "/variants/service/add/:productId", element: <ServiceVariantAdd /> },
  { path: "/variants/service/edit/:productId/:id", element: <ServiceVariantEdit /> },
  { path: "/lake-variants/edit/:productId/:id", element: <LakeVariantEdit /> },
  // { path: "/variants/edit/:productId/:id", element: <VariantEdit /> },
  { path: "/variants/edit/:productId/:id", element: <VariantEdit /> },
  // { path: "/product/add", element: <ProductAdd /> },
  // { path: "/product/edit/:id", element: <ProductEdit /> },
  // { path: "/v1/variants/add/:productId", element: <VariantAdd /> },
  // { path: "/v1/variants/edit/:productId/:id", element: <VariantEdit /> },
  { path: "/providers", element: <VendorList /> },
  { path: "/providers/add", element: <VendorAdd /> },
  { path: "/providers/edit/:id", element: <VendorEdit /> },
  { path: "/providers/view/:id", element: <VendorView /> },
  { path: "/feature", element: <FeaturePanel /> },
  { path: "/email-template", element: <EmailTemplate /> },
  { path: "/email-template/edit/:id", element: <EditEmailTemplate /> },
  { path: "/advance-providers", element: <AdvanceProviderList /> },
  { path: "/providers/profile/:id", element: <AdvanceProviderView /> },
  { path: "/provider/review/:id", element: <VendorReview /> },
  { path: "/provider/manage", element: <ManageVendor /> },
  { path: "/setting/credit-note", element: <CreditNote /> },
  { path: "/setting/provider/holiday", element: <HolidaySetting /> },
  { path: "/setting/provider/access", element: <ManageVendorAccess /> },
  { path: "/setting/provider/export", element: <ManageVendorExport /> },
  { path: "/setting/provider/advance", element: <AdvanceVendorAccess /> },
  { path: "/setting/provider/label", element: <VendorFormLabel /> },
  { path: "/setting/provider/review", element: <ManageVendorReview /> },
  { path: "/setting/plan/list", element: <SellerPlanList /> },
  { path: "/setting/plan/add", element: <AddSellerPlan /> },
  { path: "/setting/plan/preview", element: <PlanPreview /> },
  { path: "/setting/plan/edit/:id", element: <EditSubscriptionPlan /> },
  { path: "/setting/provider/subscription", element: <ManageVendorSubscription /> },
  { path: "/setting/order/packing-slip", element: <PackingSlipSetting /> },
  { path: "*", element: <NotFound /> },
];

const privateRoutes = routes.map(({ path, element }) => ({ path, element: <PrivateRoute>{element}</PrivateRoute> }));

export default privateRoutes;
